import React from "react";

export const FormCard = ({ children, title }) => {
  return (
    <div className="bg-white rounded-2xl border border-gray-200 shadow-sm p-4 sm:p-6 mb-5 sm:mb-8">
      {title && (
        <h2 className="text-lg sm:text-xl font-bold text-gray-900 mb-4 sm:mb-6 pb-3 sm:pb-4 border-b border-gray-200">
          {title}
        </h2>
      )}
      {children}
    </div>
  );
};

export const FormGrid = ({ children }) => {
  return (
    <div className="grid grid-cols-1 md:grid-cols-2 gap-4 sm:gap-6">
      {children}
    </div>
  );
};

export const ActionBar = ({ children }) => {
  return (
    <div className="flex flex-wrap justify-center gap-3 sm:gap-4 mt-6 sm:mt-8 pt-5 sm:pt-6 border-t border-gray-200 [&>*]:flex-1 sm:[&>*]:flex-none">
      {children}
    </div>
  );
};

export default FormCard;